
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 0C5.383 0 0 5.383 0 12s5.383 12 12 12 12-5.383 12-12S18.617 0 12 0zm0 19a1 1 0 110-2 1 1 0 010 2zm1.583-6.358c-.354.163-.583.52-.583.909V14a1 1 0 11-2 0v-.449c0-1.167.686-2.237 1.745-2.726C13.764 10.356 14.5 9.111 14.5 8.5 14.5 7.122 13.379 6 12 6S9.5 7.122 9.5 8.5a1 1 0 11-2 0C7.5 6.019 9.519 4 12 4s4.5 2.019 4.5 4.5c0 1.351-1.172 3.337-2.917 4.142z"}})])
          )
        }
      }
    